<template>
  <div>
    <PageAllow controller="Settings" action="thirdApiSetting" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-sheet class="page-card transparent-background-color">
        <v-card>
          <v-card-title>
            {{ $t("ThirdApiSetting.thirdApi_form") }}
          </v-card-title>
          <v-divider />
          <v-card-text class="mt-8 pb-12">
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("ThirdApiSetting.thirdApi_form_name") + $t("Global.colon")
                }}
              </v-col>
              <v-col cols="9" md="7">
                <v-autocomplete
                  v-model="push_ThirdApi_form"
                  :items="Items"
                  item-value="value"
                  item-text="text"
                  multiple
                  chips
                  clearable
                  deletable-chips
                  small-chips
                  color="primary"
                  :loading="itemsLoading"
                  item-disabled="disabled"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-expansion-panels v-model="panels" multiple focusable class="my-5">
          <!-- 通用 -->
          <v-expansion-panel
            v-show="push_ThirdApi_form.findIndex((d) => d == 1003) > -1"
          >
            <v-expansion-panel-header>
              {{
                Items.find((d) => d.value == 1003)
                  ? Items.find((d) => d.value == 1003).text
                  : ""
              }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-text class="mt-8 pb-12">
                  <!-- push_common_url -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("ThirdApiSetting.push_common_url") +
                        $t("Global.colon")
                      }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="push_common_url">
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <!--  push_common_token -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("ThirdApiSetting.push_common_token") +
                        $t("Global.colon")
                      }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="push_common_token">
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- 畅捷通 -->
          <v-expansion-panel
            v-show="push_ThirdApi_form.findIndex((d) => d == 1019) > -1"
          >
            <v-expansion-panel-header>
              {{
                Items.find((d) => d.value == 1019)
                  ? Items.find((d) => d.value == 1019).text
                  : ""
              }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-text class="mt-8 pb-12">
                  <!-- appKey -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{ $t("ThirdApiSetting.appKey") + $t("Global.colon") }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="appKey">
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <!--  appSecret -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{ $t("ThirdApiSetting.appSecret") + $t("Global.colon") }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="appSecret">
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- 客如云 -->
          <v-expansion-panel
            v-show="push_ThirdApi_form.findIndex((d) => d == 1021) > -1"
          >
            <v-expansion-panel-header>
              {{
                Items.find((d) => d.value == 1021)
                  ? Items.find((d) => d.value == 1021).text
                  : ""
              }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-text class="mt-8 pb-12">
                  <v-btn
                    color="primary"
                    class="my-1 mr-3"
                    x-small
                    outlined
                    @click="kry_shops_dialog = true"
                  >
                    {{ $t("CRUD.chooseInfo", [$t("Campaigns.shops")]) }}
                  </v-btn>
                  <v-data-table
                    :headers="shopHeaders"
                    :items="kry_shops"
                    multi-sort
                    class="elevation-1 px-4 pt-2"
                    disable-pagination
                    hide-default-footer
                    fixed-header
                  >
                    <template v-slot:header.actions="{ header }">
                      {{ header.text }}
                      <v-icon x-small>fa-sliders-h</v-icon>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-btn
                        small
                        text
                        class="primary--text pa-0"
                        @click.stop="
                          kry_setting_dialog = true;
                          currentItem = item;
                        "
                      >
                        <v-icon>fa-pencil-alt</v-icon>
                      </v-btn>
                      <v-btn
                        small
                        text
                        class="danger--text pa-0"
                        @click="
                          kry_shops.splice(
                            kry_shops.findIndex((shop) => shop.id == item.id),
                            1
                          );
                          $delete(kry_setting, item.shop_code);
                        "
                      >
                        <v-icon>fa-times</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- 花满楼 -->
          <v-expansion-panel
            v-show="push_ThirdApi_form.findIndex((d) => d == 1022) > -1"
          >
            <v-expansion-panel-header>
              {{
                Items.find((d) => d.value == 1022)
                  ? Items.find((d) => d.value == 1022).text
                  : ""
              }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-text class="mt-8 pb-12">
                  <!-- hml_db_host -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("ThirdApiSetting.hml_db_host") +
                        $t("Global.colon")
                      }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="hml_db_host">
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <!-- hml_db_port -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("ThirdApiSetting.hml_db_port") +
                        $t("Global.colon")
                      }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="hml_db_port">
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <!-- hml_db_name -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("ThirdApiSetting.hml_db_name") +
                        $t("Global.colon")
                      }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="hml_db_name">
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <!-- hml_db_user -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("ThirdApiSetting.hml_db_user") +
                        $t("Global.colon")
                      }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="hml_db_user">
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <!--  hml_db_password -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("ThirdApiSetting.hml_db_password") +
                        $t("Global.colon")
                      }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line name="hml_db_password" type="password" v-model="hml_db_password">
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- 壹分拣 -->
          <v-expansion-panel
            v-show="push_ThirdApi_form.findIndex((d) => d == 1023) > -1"
          >
            <v-expansion-panel-header>
              {{
                Items.find((d) => d.value == 1023)
                  ? Items.find((d) => d.value == 1023).text
                  : ""
              }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-text class="mt-8 pb-12">
                  <!-- yfj_url -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{ $t("ThirdApiSetting.yfj_url") + $t("Global.colon") }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="yfj_url">
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <!-- yfj_api_id -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("ThirdApiSetting.yfj_api_id") + $t("Global.colon")
                      }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="yfj_api_id">
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <!-- yfj_secret -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("ThirdApiSetting.yfj_secret") + $t("Global.colon")
                      }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="yfj_secret">
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("ThirdApiSetting.push_stock") + $t("Global.colon")
                      }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <SearcherStocks
                        v-model="yfjStocksSelected"
                        :stock-types="[0]"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <!-- 三联中台 -->
          <v-expansion-panel
            v-show="push_ThirdApi_form.findIndex((d) => d == 1025) > -1"
          >
            <v-expansion-panel-header>
              {{
              Items.find((d) => d.value == 1025)
              ? Items.find((d) => d.value == 1025).text
              : ""
              }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-text class="mt-8 pb-12">
                  <!-- sanlian_url -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{ $t("ThirdApiSetting.sanlian_url") + $t("Global.colon") }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="sanlian_url">
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <!-- sanlian_random_str -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{ $t("ThirdApiSetting.sanlian_random_str") + $t("Global.colon") }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="sanlian_random_str">
                      </v-text-field>
                    </v-col>
                  </v-row>

                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- 中仑 -->
          <v-expansion-panel v-show="push_ThirdApi_form.findIndex((d) => d == 1026) > -1">
            <v-expansion-panel-header>
              {{ Items.find((d) => d.value == 1026) ? Items.find((d) => d.value == 1026).text : "" }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-text class="mt-8 pb-12">
                  <!-- zhonglun_url -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{ $t("ThirdApiSetting.zhonglun_url") + $t("Global.colon") }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="zhonglun_url">
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <!-- zhonglun_appKey -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{ $t("ThirdApiSetting.zhonglun_appKey") + $t("Global.colon") }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="zhonglun_appKey">
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <!-- zhonglun_appSecret -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{ $t("ThirdApiSetting.zhonglun_appSecret") + $t("Global.colon") }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="zhonglun_appSecret">
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <!-- zhonglun_supplierId -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{ $t("ThirdApiSetting.zhonglun_supplierId") + $t("Global.colon") }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="zhonglun_supplierId">
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <!-- zhonglun_mid_url -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{ $t("ThirdApiSetting.zhonglun_mid_url") + $t("Global.colon") }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="zhonglun_mid_url">
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <!--  zhonglun_mid_auth -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{ $t("ThirdApiSetting.zhonglun_mid_auth") + $t("Global.colon") }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="zhonglun_mid_auth">
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- 蜂铺 -->
          <v-expansion-panel
            v-show="push_ThirdApi_form.findIndex((d) => d == 1017) > -1"
          >
            <v-expansion-panel-header>
              {{
                Items.find((d) => d.value == 1017)
                  ? Items.find((d) => d.value == 1017).text
                  : ""
              }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-text class="mt-8 pb-12">
                  <!-- fp_url -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{ $t("ThirdApiSetting.fp_url") + $t("Global.colon") }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="fp_url">
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <!--  fp_app_id -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{ $t("ThirdApiSetting.fp_app_id") + $t("Global.colon") }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="fp_app_id">
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <!--  fp_secret -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{ $t("ThirdApiSetting.fp_secret") + $t("Global.colon") }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="fp_secret">
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- 巨沃 -->
          <v-expansion-panel
            v-show="push_ThirdApi_form.findIndex((d) => d == 2002) > -1"
          >
            <v-expansion-panel-header>
              {{
                Items.find((d) => d.value == 2002)
                  ? Items.find((d) => d.value == 2002).text
                  : ""
              }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-text class="mt-8 pb-12">
                  <!-- push_shop  -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("ThirdApiSetting.push_shop", [$consts.shopName()]) +
                        $t("Global.colon")
                      }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <SearcherShops v-model="shopsSelected" />
                    </v-col>
                  </v-row>
                  <!--  push_stock  -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("ThirdApiSetting.push_stock") + $t("Global.colon")
                      }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <SearcherStocks
                        v-model="stocksSelected"
                        :stock-types="[0]"
                      />
                    </v-col>
                  </v-row>
                  <!--  push_gwall_url   -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("ThirdApiSetting.push_gwall_url ") +
                        $t("Global.colon")
                      }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="push_gwall_url">
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- 中仑 -->
          <v-expansion-panel
            v-show="push_ThirdApi_form.findIndex((d) => d == 2001) > -1"
          >
            <v-expansion-panel-header>
              {{
                Items.find((d) => d.value == 2001)
                  ? Items.find((d) => d.value == 2001).text
                  : ""
              }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-text class="mt-8 pb-12">
                  <!-- push_mid_url -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("ThirdApiSetting.push_mid_url") + $t("Global.colon")
                      }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="push_mid_url">
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <!--  push_mid_auth -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("ThirdApiSetting.push_mid_auth") + $t("Global.colon")
                      }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="push_mid_auth">
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <!--  push_mid_token -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("ThirdApiSetting.push_mid_token") +
                        $t("Global.colon")
                      }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="push_mid_token">
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- 金蝶 -->
          <v-expansion-panel
            v-show="push_ThirdApi_form.findIndex((d) => d == 1018) > -1"
          >
            <v-expansion-panel-header>
              {{
                Items.find((d) => d.value == 1018)
                  ? Items.find((d) => d.value == 1018).text
                  : ""
              }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-text class="mt-8 pb-12">
                  <!-- push_kingdee_url -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("ThirdApiSetting.push_kingdee_url") +
                        $t("Global.colon")
                      }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="push_kingdee_url">
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <!--  push_kingdee_auth -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("ThirdApiSetting.push_kingdee_auth") +
                        $t("Global.colon")
                      }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="push_kingdee_auth">
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <!--  push_kingdee_token -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("ThirdApiSetting.push_kingdee_token") +
                        $t("Global.colon")
                      }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="push_kingdee_token">
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- 一言为订中台 -->
          <v-expansion-panel
            v-show="push_ThirdApi_form.findIndex((d) => d == 2101) > -1"
          >
            <v-expansion-panel-header>
              {{
                Items.find((d) => d.value == 2101)
                  ? Items.find((d) => d.value == 2101).text
                  : ""
              }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-text class="mt-8 pb-12">
                  <!-- push_middleware_url -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("ThirdApiSetting.push_middleware_url") +
                        $t("Global.colon")
                      }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="push_middleware_url">
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <!--  push_middleware_auth -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("ThirdApiSetting.push_middleware_auth") +
                        $t("Global.colon")
                      }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="push_middleware_auth">
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <!--  基础信息来源 -->
                  <!-- <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("ThirdApiSetting.sync_base_data_from") +
                        $t("Global.colon")
                      }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-radio-group
                          row
                          v-model="sync_base_data_from"
                        >
                          <v-radio
                            :label="$t('ThirdApiSetting.sync_data_from_yywd')"
                            :key="0"
                            :value="0"
                          />
                          <v-radio
                            :label="$t('ThirdApiSetting.sync_data_from_kingdee')"
                            :key="1"
                            :value="1"
                          />
                        </v-radio-group>
                    </v-col>
                  </v-row> -->
                  <!-- 商品信息来源 -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("ThirdApiSetting.sync_material_data_from") +
                        $t("Global.colon")
                      }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-radio-group row v-model="sync_material_data_from">
                        <v-radio
                          :label="$t('ThirdApiSetting.sync_data_from_yywd')"
                          :key="0"
                          :value="0"
                        />
                        <v-radio
                          :label="$t('ThirdApiSetting.sync_data_from_kingdee')"
                          :key="1"
                          :value="1"
                        />
                      </v-radio-group>
                    </v-col>
                  </v-row>

                  <!-- 新增商品绑定模板 -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("ThirdApiSetting.new_material_bind_template") +
                        $t("Global.colon")
                      }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-radio-group row v-model="new_material_bind_template">
                        <v-radio
                            :label="$t('ThirdApiSetting.switch.off')"
                            :key="0"
                            :value="0"
                        />
                        <v-radio
                            :label="$t('ThirdApiSetting.switch.on')"
                            :key="1"
                            :value="1"
                        />
                      </v-radio-group>
                    </v-col>
                  </v-row>
                  <v-row align="center" v-if="new_material_bind_template == 1">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("Template.title") +
                        $t("Global.colon")
                      }}
                      <br />
                      <v-btn
                        color="primary"
                        class="my-1 mr-3"
                        small
                        outlined
                        @click="templatesDialog = true"
                      >
                        {{ $t("CRUD.chooseInfo", [$t("Template.title")]) }}
                      </v-btn>
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-data-table
                          :headers="templatesHeaders"
                          :items="templates"
                          multi-sort
                          class="elevation-1 px-4 pt-2"
                          disable-pagination
                          hide-default-footer
                          fixed-header
                      >
                        <template v-slot:header.actions>
                          <!-- 删除按钮 -->
                          <v-btn
                              small
                              text
                              class="danger--text pa-0"
                              @click="templates = []"
                          >
                            <v-icon>fa-times</v-icon>
                          </v-btn>
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <!-- 删除商品按钮 -->
                          <v-btn
                              small
                              text
                              class="danger--text pa-0"
                              @click="
                              templates.splice(
                                templates.findIndex(
                                  (template) => template.id == item.id
                                ),
                                1
                              )
                            "
                          >
                            <v-icon>fa-times</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>

                  <!-- 新增商品绑定仓库 -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("ThirdApiSetting.new_material_bind_stock") +
                        $t("Global.colon")
                      }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-radio-group row v-model="new_material_bind_stock">
                        <v-radio
                            :label="$t('ThirdApiSetting.switch.off')"
                            :key="0"
                            :value="0"
                        />
                        <v-radio
                            :label="$t('ThirdApiSetting.switch.on')"
                            :key="1"
                            :value="1"
                        />
                      </v-radio-group>
                    </v-col>
                  </v-row>
                  <v-row align="center" v-if="new_material_bind_stock == 1">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("Stock.ObjectName") +
                        $t("Global.colon")
                      }}
                      <br />
                      <v-btn
                          color="primary"
                          class="my-1 mr-3"
                          small
                          outlined
                          @click="stocksDialog = true"
                      >
                        {{ $t("CRUD.chooseInfo", [$t("Stock.ObjectName")]) }}
                      </v-btn>
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-data-table
                        :headers="stocksHeaders"
                        :items="stocks"
                        multi-sort
                        class="elevation-1 px-4 pt-2"
                        disable-pagination
                        hide-default-footer
                        fixed-header
                      >
                        <template v-slot:header.actions>
                          <!-- 删除按钮 -->
                          <v-btn
                            small
                            text
                            class="danger--text pa-0"
                            @click="stocks = []"
                          >
                            <v-icon>fa-times</v-icon>
                          </v-btn>
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <!-- 删除商品按钮 -->
                          <v-btn
                            small
                            text
                            class="danger--text pa-0"
                            @click="
                              stocks.splice(
                                stocks.findIndex(
                                  (stock) => stock.id == item.id
                                ),
                                1
                              )
                            "
                          >
                            <v-icon>fa-times</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>

                  <!-- 新增商品绑定平台供应商 -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("ThirdApiSetting.new_material_bind_yywd_supplier") +
                        $t("Global.colon")
                      }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-radio-group row v-model="new_material_bind_yywd_supplier">
                        <v-radio
                          :label="$t('ThirdApiSetting.switch.off')"
                          :key="0"
                          :value="0"
                        />
                        <v-radio
                          :label="$t('ThirdApiSetting.switch.on')"
                          :key="1"
                          :value="1"
                        />
                      </v-radio-group>
                    </v-col>
                  </v-row>
                  <v-row align="center" v-if="new_material_bind_yywd_supplier == 1">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("Supplier.SupplyType.platform") +
                        $t("Global.colon")
                      }}
                      <br />
                      <v-btn
                        color="primary"
                        class="my-1 mr-3"
                        small
                        outlined
                        @click="suppliersDialog = true"
                      >
                        {{ $t("CRUD.chooseInfo", [$t("Supplier.SupplyType.platform")]) }}
                      </v-btn>
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-data-table
                        :headers="supplierHeaders"
                        :items="suppliers"
                        multi-sort
                        class="elevation-1 px-4 pt-2"
                        disable-pagination
                        hide-default-footer
                        fixed-header
                      >
                        <template v-slot:header.actions>
                          <!-- 删除按钮 -->
                          <v-btn
                            small
                            text
                            class="danger--text pa-0"
                            @click="stocks = []"
                          >
                            <v-icon>fa-times</v-icon>
                          </v-btn>
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <!-- 删除商品按钮 -->
                          <v-btn
                            small
                            text
                            class="danger--text pa-0"
                            @click="
                              suppliers.splice(
                                suppliers.findIndex(
                                  (supplier) => supplier.id == item.id
                                ),
                                1
                              )
                            "
                          >
                            <v-icon>fa-times</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>

                  <!-- 新增商品绑定普通供应商 -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("ThirdApiSetting.new_material_bind_common_supplier") +
                        $t("Global.colon")
                      }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-radio-group row v-model="new_material_bind_common_supplier">
                        <v-radio
                          :label="$t('ThirdApiSetting.switch.off')"
                          :key="0"
                          :value="0"
                        />
                        <v-radio
                          :label="$t('ThirdApiSetting.switch.on')"
                          :key="1"
                          :value="1"
                        />
                      </v-radio-group>
                    </v-col>
                  </v-row>
                  <v-row align="center" v-if="new_material_bind_common_supplier == 1">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("Supplier.SupplyType.common") +
                        $t("Global.colon")
                      }}
                      <br />
                      <v-btn
                        color="primary"
                        class="my-1 mr-3"
                        small
                        outlined
                        @click="commonSuppliersDialog = true"
                      >
                        {{ $t("CRUD.chooseInfo", [$t("Supplier.SupplyType.common")]) }}
                      </v-btn>
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-data-table
                          :headers="supplierHeaders"
                          :items="commonSuppliers"
                          multi-sort
                          class="elevation-1 px-4 pt-2"
                          disable-pagination
                          hide-default-footer
                          fixed-header
                      >
                        <template v-slot:header.actions>
                          <!-- 删除按钮 -->
                          <v-btn
                              small
                              text
                              class="danger--text pa-0"
                              @click="commonSuppliers = []"
                          >
                            <v-icon>fa-times</v-icon>
                          </v-btn>
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <!-- 删除商品按钮 -->
                          <v-btn
                              small
                              text
                              class="danger--text pa-0"
                              @click="
                              commonSuppliers.splice(
                                commonSuppliers.findIndex(
                                  (supplier) => supplier.id == item.id
                                ),
                                1
                              )
                            "
                          >
                            <v-icon>fa-times</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>

                  <!-- 供应商信息来源 -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("ThirdApiSetting.sync_supplier_data_from") +
                        $t("Global.colon")
                      }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-radio-group row v-model="sync_supplier_data_from">
                        <v-radio
                          :label="$t('ThirdApiSetting.sync_data_from_yywd')"
                          :key="0"
                          :value="0"
                        />
                        <v-radio
                          :label="$t('ThirdApiSetting.sync_data_from_kingdee')"
                          :key="1"
                          :value="1"
                        />
                      </v-radio-group>
                    </v-col>
                  </v-row>
                  <!-- 门店信息来源 -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("ThirdApiSetting.sync_shop_data_from") +
                        $t("Global.colon")
                      }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-radio-group row v-model="sync_shop_data_from">
                        <v-radio
                          :label="$t('ThirdApiSetting.sync_data_from_yywd')"
                          :key="0"
                          :value="0"
                        />
                        <v-radio
                          :label="$t('ThirdApiSetting.sync_data_from_kingdee')"
                          :key="1"
                          :value="1"
                        />
                        <v-radio
                          :label="$t('ThirdApiSetting.sync_data_from_user')"
                          :key="2"
                          :value="2"
                        />
                      </v-radio-group>
                    </v-col>
                  </v-row>
                  <!-- 销售订单生成方式 -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("ThirdApiSetting.sync_kingdee_sell_order") +
                        $t("Global.colon")
                      }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-radio-group row v-model="sync_kingdee_sell_order">
                        <v-radio
                          :label="$t('ThirdApiSetting.sync_kingdee_sell_order_by_order')"
                          :key="0"
                          :value="0"
                        />
                        <v-radio
                          :label="$t('ThirdApiSetting.sync_kingdee_sell_order_by_stockOrder')"
                          :key="1"
                          :value="1"
                        />
                      </v-radio-group>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- TopMall -->
          <v-expansion-panel
            v-show="push_ThirdApi_form.findIndex((d) => d == 1012) > -1"
          >
            <v-expansion-panel-header>
              {{
                Items.find((d) => d.value == 1012)
                  ? Items.find((d) => d.value == 1012).text
                  : ""
              }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-text class="mt-8 pb-12">
                  <!-- push_topmall_url -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("ThirdApiSetting.push_topmall_url") +
                        $t("Global.colon")
                      }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="push_topmall_url">
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <!--  push_topmall_token -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("ThirdApiSetting.push_topmall_token") +
                        $t("Global.colon")
                      }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="push_topmall_token">
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- 优品商通 -->
          <v-expansion-panel
            v-show="push_ThirdApi_form.findIndex((d) => d == 1013) > -1"
          >
            <v-expansion-panel-header>
              {{
                Items.find((d) => d.value == 1013)
                  ? Items.find((d) => d.value == 1013).text
                  : ""
              }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-text class="mt-8 pb-12">
                  <!-- push_ut_url -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("ThirdApiSetting.push_ut_url") + $t("Global.colon")
                      }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="push_ut_url">
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <!--  push_ut_token -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("ThirdApiSetting.push_ut_token") + $t("Global.colon")
                      }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="push_ut_token">
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <!--  push_ut_auth -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("ThirdApiSetting.push_ut_auth") + $t("Global.colon")
                      }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="push_ut_auth">
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- 西贝 -->
          <v-expansion-panel v-show="push_ThirdApi_form.findIndex((d) => d == 1014) > -1">
            <v-expansion-panel-header>
              {{ Items.find((d) => d.value == 1014) ? Items.find((d) => d.value == 1014).text : "" }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-text class="mt-8 pb-12">
                  <!-- push_xibei_url -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{ $t("ThirdApiSetting.push_xibei_url") + $t("Global.colon") }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="push_xibei_url">
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <!--  push_xibei_appkey -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{ $t("ThirdApiSetting.push_xibei_appkey") + $t("Global.colon") }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="push_xibei_appkey">
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <!--  push_xibei_supplier_code -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{ $t("ThirdApiSetting.push_xibei_supplier_code") + $t("Global.colon") }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="push_xibei_supplier_code">
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <!--  push_xibei_supplier_name -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{ $t("ThirdApiSetting.push_xibei_supplier_name") + $t("Global.colon") }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="push_xibei_supplier_name">
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <!--  push_xibei_publickey -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{ $t("ThirdApiSetting.push_xibei_publickey") + $t("Global.colon") }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-textarea
                        v-model="push_xibei_publickey"
                        outlined
                        rows="3"
                      />
                    </v-col>
                  </v-row>
                  <!--  push_xibei_notice_email -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{ $t("ThirdApiSetting.push_xibei_notice_email") + $t("Global.colon") }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="push_xibei_notice_email">
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <!--  push_xibei_notice_phone -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{ $t("ThirdApiSetting.push_xibei_notice_phone") + $t("Global.colon") }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="push_xibei_notice_phone">
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-data-table
                    :headers="stockHeaders"
                    :items="xibei_stocks"
                    multi-sort
                    class="elevation-1 px-4 pt-2"
                    disable-pagination
                    hide-default-footer
                    fixed-header
                  >
                    <!-- 供应商编码 -->
                    <template v-slot:item.supplier_code="{ item }">
                      <v-text-field
                        v-model="item.supplier_code"
                        outlined
                        dense
                        hide-details
                      />
                    </template>
                    <!-- 供应商名称 -->
                    <template v-slot:item.supplier_name="{ item }">
                      <v-text-field
                        v-model="item.supplier_name"
                        outlined
                        dense
                        hide-details
                      />
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <!-- 壹向 -->
          <v-expansion-panel
            v-show="push_ThirdApi_form.findIndex((d) => d == 2003) > -1"
          >
            <v-expansion-panel-header>
              {{
                Items.find((d) => d.value == 2003)
                  ? Items.find((d) => d.value == 2003).text
                  : ""
              }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-text class="mt-8 pb-12">
                  <!-- yx_url -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{ $t("ThirdApiSetting.yx_url") + $t("Global.colon") }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="yx_url">
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <!--  yx_app_id -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{ $t("ThirdApiSetting.yx_app_id") + $t("Global.colon") }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="yx_app_id">
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <!--  yx_app_key -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("ThirdApiSetting.yx_app_key") + $t("Global.colon")
                      }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="yx_app_key">
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <!--  yx_brand_id -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("ThirdApiSetting.yx_brand_id") + $t("Global.colon")
                      }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-text-field single-line v-model="yx_brand_id">
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-sheet>
      <v-sheet class="page-opts">
        <v-card>
          <v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-btn color="success" block @click="save()">
                  <v-icon small class="pe-1">fa-save</v-icon>
                  {{ $t("CRUD.save") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-sheet>
    </v-sheet>
    <DialogShops
      v-model="kry_shops_dialog"
      isShopPsi
      :shopSelectedId="kry_shops ? kry_shops.map((e) => {return e.id;}): []"
      @add="addShop($event)"
      @confirm="kry_shops = $event"
    />
    <DialogKeRuYunSetting
      v-model="kry_setting_dialog"
      :setting="
        currentItem && kry_setting[currentItem.shop_code]
          ? kry_setting[currentItem.shop_code]
          : null
      "
      :shop="currentItem"
      @confirm="$set(kry_setting, currentItem.shop_code, $event)"
    />
    <StocksSelectsDialog
      v-model="stocksDialog"
      :stockIds="stockIds"
      :status="[1]"
      @confirm="choosedStocks = $event"
    />
    <TemplatesSelectsDialog
      v-model="templatesDialog"
      :templateIds="templateIds"
      @confirm="choosedTemplates = $event"
    />
    <SuppliersSelectsDialog
      v-model="suppliersDialog"
      :type="2"
      signleFlg
      :supplierIds="supplierIds"
      @confirm="choosedSuppliers = $event"
    />
    <SuppliersSelectsDialog
      v-model="commonSuppliersDialog"
      :type="1"
      :supplierIds="commonSupplierIds"
      @confirm="choosedCommonSuppliers = $event"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import Settings from "@/api/settings";
import Stocks from "@/api/stocks";
import SearcherShops from "@/components/plugins/SearcherShops";
import SearcherStocks from "@/components/plugins/SearcherStocks";
import DialogShops from "@/components/plugins/DialogShops";
import DialogKeRuYunSetting from "./plugins/DialogKeRuYunSetting";
import StocksSelectsDialog from "@/components/plugins/StocksSelectsDialog";
import SuppliersSelectsDialog from "@/components/plugins/SuppliersSelectsDialog";
import TemplatesSelectsDialog from "@/components/plugins/TemplatesSelectsDialog";
import Template from "@/api/templates";
import Suppliers from "@/api/suppliers";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherShops,
    SearcherStocks,
    DialogShops,
    DialogKeRuYunSetting,
    StocksSelectsDialog,
    SuppliersSelectsDialog,
    TemplatesSelectsDialog,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("SettingNav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("SettingNav.settings"),
        disabled: false,
        href: "/settings/bussiness-settings",
      },
      {
        text: i18n.t("logisticsApiSetting.ext_api"),
        disabled: true,
        href: "/settings/logistics-api-setting",
      },
    ],
    shopHeaders() {
      let headers = [
        {
          text: i18n.t("Shop.Fields.shop_code", [this.$consts.shopName()]),
          align: "start",
          sortable: false,
          value: "shop_code",
        },
        {
          text: i18n.t("Shop.Fields.shop_name", [this.$consts.shopName()]),
          align: "start",
          sortable: false,
          value: "shop_name",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "center",
          sortable: false,
          value: "actions",
        },
      ];
      return headers;
    },
    stockHeaders() {
      let headers = [
        {
          text: i18n.t("ThirdApiSetting.push_stock"),
          align: "start",
          sortable: false,
          value: "name",
        },
        {
          text: i18n.t("SupplierScoreLog.Fields.supplier_code"),
          align: "start",
          sortable: false,
          value: "supplier_code",
        },
        {
          text: i18n.t("SupplierScoreLog.Fields.supplier_name"),
          align: "start",
          sortable: false,
          value: "supplier_name",
        },
      ];
      return headers
    },
    stocksHeaders: () => [
      {
        text: i18n.t("Stock.Fields.stock_code"),
        align: "start",
        sortable: false,
        value: "code",
      },
      {
        text: i18n.t("Stock.Fields.stock_name"),
        align: "start",
        sortable: false,
        value: "name",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "end",
        sortable: false,
        value: "actions",
      }
    ],
    templatesHeaders: () => [
      {
        text: i18n.t("Template.Fields.template_name"),
        align: "start",
        sortable: true,
        filterable: true,
        value: "template_name",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "end",
        sortable: false,
        value: "actions",
      }
    ],
    supplierHeaders: () => [
      {
        text: i18n.t("Supplier.Fields.supplier_code"),
        align: "start",
        sortable: false,
        value: "supplier_code",
      },
      {
        text: i18n.t("Supplier.Fields.supplier_name"),
        align: "start",
        sortable: false,
        value: "supplier_name",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "end",
        sortable: false,
        value: "actions",
      }
    ],

    // ThirdApiItems() {
    //   return this.Items.map((item) => {
    //     if (
    //       this.push_ThirdApi_form.findIndex((e) => e == 1003) > -1 &&
    //       item.value != 1003
    //     ) {
    //       // 单选
    //       item.disabled = true;
    //     } else if (
    //       this.push_ThirdApi_form.findIndex((e) => e == 1012) > -1 &&
    //       item.value != 1012
    //     ) {
    //       // 单选
    //       item.disabled = true;
    //     } else if (
    //       this.push_ThirdApi_form.findIndex((e) => e == 1013) > -1 &&
    //       item.value != 1013
    //     ) {
    //       // 单选
    //       item.disabled = true;
    //     } else if (
    //       this.push_ThirdApi_form.findIndex((e) => e == 1017) > -1 &&
    //       item.value != 1017
    //     ) {
    //       // 单选
    //       item.disabled = true;
    //     } else if (
    //       this.push_ThirdApi_form.findIndex((e) => e == 2001) > -1 &&
    //       item.value != 2001
    //     ) {
    //       // 单选
    //       item.disabled = true;
    //     } else if (
    //       this.push_ThirdApi_form.findIndex((e) => e == 1018) > -1 &&
    //       item.value != 1018
    //     ) {
    //       // 单选
    //       item.disabled = true;
    //     } else if (this.push_ThirdApi_form.findIndex((e) => e == 2002) > -1) {
    //       // 多选
    //       if (
    //         item.value == 1003 ||
    //         item.value == 1012 ||
    //         item.value == 1013 ||
    //         item.value == 1017 ||
    //         item.value == 2001 ||
    //         item.value == 1018
    //       ) {
    //         item.disabled = true;
    //       } else {
    //         item.disabled = false;
    //       }
    //     } else if (this.push_ThirdApi_form.findIndex((e) => e == 1019) > -1) {
    //       // 多选
    //       if (
    //         item.value == 1003 ||
    //         item.value == 1012 ||
    //         item.value == 1013 ||
    //         item.value == 1017 ||
    //         item.value == 2001 ||
    //         item.value == 1018
    //       ) {
    //         item.disabled = true;
    //       } else {
    //         item.disabled = false;
    //       }
    //     } else if (this.push_ThirdApi_form.findIndex((e) => e == 2003) > -1) {
    //       // 多选
    //       if (
    //         item.value == 1003 ||
    //         item.value == 1012 ||
    //         item.value == 1013 ||
    //         item.value == 1017 ||
    //         item.value == 2001 ||
    //         item.value == 1018
    //       ) {
    //         item.disabled = true;
    //       } else {
    //         item.disabled = false;
    //       }
    //     } else {
    //       item.disabled = false;
    //     }
    //     return item;
    //   });
    // },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "accountInfo"]),
  },

  data: () => ({
    setting: {},
    panels: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    push_ThirdApi_form: [],
    third_api_select: {},
    Items: [],
    itemsLoading: false,
    push_common_url: null,
    push_common_token: null,
    appKey: null,
    appSecret: null,
    fp_url: null,
    fp_app_id: null,
    fp_secret: null,
    push_shop: null,
    push_stock: null,
    push_gwall_url: null,
    push_mid_url: null,
    push_mid_auth: null,
    push_mid_token: null,
    push_kingdee_url: null,
    push_kingdee_auth: null,
    push_kingdee_token: null,
    push_middleware_url: null,
    push_middleware_auth: null,
    // sync_base_data_from: 0,
    sync_material_data_from: 0,
    new_material_bind_template: 0,
    new_material_bind_stock: 0,
    new_material_bind_yywd_supplier: 0,
    new_material_bind_common_supplier: 0,
    sync_supplier_data_from: 0,
    sync_shop_data_from: 0,
    sync_kingdee_sell_order: 0,

    push_topmall_url: null,
    push_topmall_token: null,
    push_ut_url: null,
    push_ut_token: null,
    push_ut_auth: null,
    yx_url: null,
    yx_app_id: null,
    yx_app_key: null,
    yx_brand_id: null,
    shopsSelected: [],
    stocksSelected: [],
    kry_shops_dialog: false,
    kry_setting_dialog: false,
    kry_shops: [],
    kry_setting: {},
    currentItem: null,
    yfj_url: null,
    yfj_api_id: null,
    yfj_secret: null,
    yfjStocksSelected: [],
    yfj_stocks: [],
    hml_db_host: null,
    hml_db_port: null,
    hml_db_name: null,
    hml_db_user: null,
    hml_db_password: null,
    sanlian_url: null,
    sanlian_random_str: null,
    push_xibei_url: null,
    push_xibei_appkey: null,
    push_xibei_supplier_code: null,
    push_xibei_supplier_name: null,
    push_xibei_publickey: null,
    push_xibei_notice_email: null,
    push_xibei_notice_phone: null,
    xibei_stock_settings: null,
    xibei_stocks: [],
    zhonglun_url: null,
    zhonglun_appKey: null,
    zhonglun_appSecret: null,
    zhonglun_supplierId: null,
    zhonglun_mid_url: null,
    zhonglun_mid_auth: null,
    templatesDialog: false,
    templates: [],
    templateIds: [],
    choosedTemplates: [], //每次选中的模板
    stocksDialog: false,
    stocks: [],
    stockIds: [],
    choosedStocks: [], //每次选中的仓库
    suppliersDialog: false,
    suppliers: [],
    supplierIds: [],
    choosedSuppliers: [], //每次选中的平台供应商
    commonSuppliersDialog: false,
    commonSuppliers: [],
    commonSupplierIds: [],
    choosedCommonSuppliers: [], //每次选中的普通供应商
  }),

  mounted() {
    this.itemsLoading = true;
    Settings.getThirdApiSelect().then(
      function (response) {
        if (response.data.status.isOK()) {
          this.third_api_select = response.data.third_api_select;
          this.Items = Object.keys(this.third_api_select).map((key) => {
            return {
              text: this.third_api_select[key],
              value: key,
            };
          });
          this.getThirdApiSettingFromAPI();
        }
        this.itemsLoading = false;
      }.bind(this)
    );
  },

  methods: {
    getThirdApiSettingFromAPI() {
      Settings.getThirdApiSetting().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.push_common_url = null;
            this.push_common_token = null;
            this.appKey = null;
            this.appSecret = null;
            this.fp_url = null;
            this.fp_app_id = null;
            this.fp_secret = null;
            this.push_shop = null;
            this.push_stock = null;
            this.push_gwall_url = null;
            this.push_mid_url = null;
            this.push_mid_auth = null;
            this.push_mid_token = null;
            this.push_kingdee_url = null;
            this.push_kingdee_auth = null;
            this.push_kingdee_token = null;
            this.push_middleware_url = null;
            this.push_middleware_auth = null;
            this.sync_base_data_from = 0;
            this.sync_material_data_from = 0;
            this.new_material_bind_template = 0;
            this.templateIds = [],
            this.new_material_bind_stock = 0;
            this.stockIds = [],
            this.new_material_bind_yywd_supplier = 0;
            this.supplierIds = [];
            this.new_material_bind_common_supplier = 0;
            this.commonSupplierIds = [];
            this.sync_supplier_data_from = 0;
            this.sync_shop_data_from = 0;
            this.sync_kingdee_sell_order = 0;
            this.push_topmall_url = null;
            this.push_topmall_token = null;
            this.push_ut_url = null;
            this.push_ut_token = null;
            this.push_ut_auth = null;
            this.yx_url = null;
            this.yx_app_id = null;
            this.yx_app_key = null;
            this.yx_brand_id = null;
            this.shopsSelected = [];
            this.stocksSelected = [];
            this.yfj_url = null;
            this.yfj_api_id = null;
            this.yfj_secret = null;
            this.yfjStocksSelected = [];
            this.yfj_stocks = [];
            this.hml_db_host = null;
            this.hml_db_port = null;
            this.hml_db_name = null;
            this.hml_db_user = null;
            this.hml_db_password = null;
            this.sanlian_url = null;
            this.sanlian_random_str = null;
            this.zhonglun_url = null;
            this.zhonglun_appKey = null;
            this.zhonglun_appSecret = null;
            this.zhonglun_supplierId = null;
            this.zhonglun_mid_url = null;
            this.zhonglun_mid_auth = null;
            this.push_ThirdApi_form =
              response.data.third_api_settings != "null"
                ? Object.keys(response.data.third_api_settings)
                : [];
            var third_api_settings = response.data.third_api_settings;
            this.push_ThirdApi_form.forEach((d) => {
              if (d == 1003) {
                this.push_common_url = third_api_settings[d].push_common_url;
                this.push_common_token =
                  third_api_settings[d].push_common_token;
              }
              if (d == 1019) {
                this.appKey = third_api_settings[d].appKey;
                this.appSecret = third_api_settings[d].appSecret;
              }
              if (d == 1017) {
                this.fp_url = third_api_settings[d].fp_url;
                this.fp_app_id = third_api_settings[d].fp_app_id;
                this.fp_secret = third_api_settings[d].fp_secret;
              }
              if (d == 1021) {
                this.kry_shops = response.data.kry_shops;
                this.kry_setting = third_api_settings[d];
              }
              if (d == 1022) {
                this.hml_db_host = third_api_settings[d].hml_db_host;
                this.hml_db_port = third_api_settings[d].hml_db_port;
                this.hml_db_name = third_api_settings[d].hml_db_name;
                this.hml_db_user = third_api_settings[d].hml_db_user;
              }
              if (d == 1023) {
                this.yfj_url = third_api_settings[d].url;
                this.yfj_api_id = third_api_settings[d].api_id;
                this.yfj_secret = third_api_settings[d].secret;
                this.yfjStocksSelected = third_api_settings[d].stocks.map(
                  (k) => {
                    return { id: k };
                  }
                );
              }
              if (d == 1025) {
                this.sanlian_url = third_api_settings[d].sanlian_url;
                this.sanlian_random_str = third_api_settings[d].sanlian_random_str;
              }
              if (d == 1026) {
                this.zhonglun_url = third_api_settings[d].zhonglun_url;
                this.zhonglun_appKey = third_api_settings[d].zhonglun_appKey;
                this.zhonglun_appSecret = third_api_settings[d].zhonglun_appSecret;
                this.zhonglun_supplierId = third_api_settings[d].zhonglun_supplierId;
                this.zhonglun_mid_url = third_api_settings[d].zhonglun_mid_url;
                this.zhonglun_mid_auth = third_api_settings[d].zhonglun_mid_auth;
              }
              if (d == 2002) {
                this.push_shop = third_api_settings[d].push_shop;
                this.push_stock = third_api_settings[d].push_stock;
                this.push_gwall_url = third_api_settings[d].push_gwall_url;
                this.shopsSelected = third_api_settings[d].push_shop.map(
                  (k) => {
                    return { id: k };
                  }
                );
                this.stocksSelected = third_api_settings[d].push_stock.map(
                  (k) => {
                    return { id: k };
                  }
                );
              }
              if (d == 2001) {
                this.push_mid_url = third_api_settings[d].push_mid_url;
                this.push_mid_auth = third_api_settings[d].push_mid_auth;
                this.push_mid_token = third_api_settings[d].push_mid_token;
              }
              if (d == 1018) {
                this.push_kingdee_url = third_api_settings[d].push_kingdee_url;
                this.push_kingdee_auth =
                  third_api_settings[d].push_kingdee_auth;
                this.push_kingdee_token =
                  third_api_settings[d].push_kingdee_token;
              }
              if (d == 2101) {
                this.push_middleware_url =
                  third_api_settings[d].push_middleware_url;
                this.push_middleware_auth =
                  third_api_settings[d].push_middleware_auth;
                // this.sync_base_data_from =
                //   third_api_settings[d].sync_base_data_from == undefined
                //     ? 0
                //     : third_api_settings[d].sync_base_data_from;
                this.sync_material_data_from =
                  third_api_settings[d].sync_material_data_from == undefined
                    ? 0
                    : third_api_settings[d].sync_material_data_from;
                this.new_material_bind_template =
                    third_api_settings[d].new_material_bind_template == undefined
                        ? 0
                        : third_api_settings[d].new_material_bind_template;
                this.templateIds =
                    third_api_settings[d].bind_template_ids == undefined
                        ? []
                        : third_api_settings[d].bind_template_ids;
                this.getTemplatesFromApi();
                this.new_material_bind_stock =
                    third_api_settings[d].new_material_bind_stock == undefined
                        ? 0
                        : third_api_settings[d].new_material_bind_stock;
                this.stockIds =
                    third_api_settings[d].bind_stock_ids == undefined
                        ? []
                        : third_api_settings[d].bind_stock_ids;
                this.getStocksFromApi();
                this.new_material_bind_yywd_supplier =
                    third_api_settings[d].new_material_bind_yywd_supplier == undefined
                        ? 0
                        : third_api_settings[d].new_material_bind_yywd_supplier;
                this.supplierIds = third_api_settings[d].bind_yywd_supplier_ids === undefined
                        ? []
                        : third_api_settings[d].bind_yywd_supplier_ids;
                this.new_material_bind_common_supplier =
                    third_api_settings[d].new_material_bind_common_supplier == undefined
                        ? 0
                        : third_api_settings[d].new_material_bind_common_supplier;
                this.commonSupplierIds = third_api_settings[d].bind_common_supplier_ids === undefined
                        ? []
                        : third_api_settings[d].bind_common_supplier_ids;
                this.getSuppliersFromApi();
                this.sync_supplier_data_from =
                  third_api_settings[d].sync_supplier_data_from == undefined
                    ? 0
                    : third_api_settings[d].sync_supplier_data_from;
                this.sync_shop_data_from =
                  third_api_settings[d].sync_shop_data_from == undefined
                    ? 0
                    : third_api_settings[d].sync_shop_data_from;
                this.sync_kingdee_sell_order =
                  third_api_settings[d].sync_kingdee_sell_order == undefined
                    ? 0
                    : third_api_settings[d].sync_kingdee_sell_order
              }
              if (d == 1012) {
                this.push_topmall_url = third_api_settings[d].push_topmall_url;
                this.push_topmall_token =
                  third_api_settings[d].push_topmall_token;
              }
              if (d == 1013) {
                this.push_ut_url = third_api_settings[d].push_ut_url;
                this.push_ut_token = third_api_settings[d].push_ut_token;
                this.push_ut_auth = third_api_settings[d].push_ut_auth;
              }

              if (d == 1014) {
                this.push_xibei_url = third_api_settings[d].push_xibei_url;
                this.push_xibei_appkey = third_api_settings[d].push_xibei_appkey;
                this.push_xibei_supplier_code = third_api_settings[d].push_xibei_supplier_code;
                this.push_xibei_supplier_name = third_api_settings[d].push_xibei_supplier_name;
                this.push_xibei_publickey = third_api_settings[d].push_xibei_publickey;
                this.push_xibei_notice_email = third_api_settings[d].push_xibei_notice_email;
                this.push_xibei_notice_phone = third_api_settings[d].push_xibei_notice_phone;
                this.xibei_stock_settings = third_api_settings[d].xibei_stock_settings;
                // 西贝获取仓库列表
                this.getStockList()
              }

              if (d == 2003) {
                this.yx_url = third_api_settings[d].yx_url;
                this.yx_app_id = third_api_settings[d].yx_app_id;
                this.yx_app_key = third_api_settings[d].yx_app_key;
                this.yx_brand_id = third_api_settings[d].yx_brand_id;
              }
            });
          }
        }.bind(this)
      );
    },

    save() {
      var data = {};
      if (this.push_ThirdApi_form.length) {
        this.push_ThirdApi_form.forEach((key) => {
          if (key == 1003) {
            Object.assign(data, {
              1003: {
                push_common_url: this.push_common_url,
                push_common_token: this.push_common_token,
              },
            });
          }
          if (key == 1019) {
            Object.assign(data, {
              1019: {
                appKey: this.appKey,
                appSecret: this.appSecret,
              },
            });
          }
          if (key == 1021) {
            Object.assign(data, {
              1021: this.kry_setting,
            });
          }
          if (key == 1022) {
            Object.assign(data, {
              1022: {
                hml_db_host: this.hml_db_host,
                hml_db_port: this.hml_db_port,
                hml_db_name: this.hml_db_name,
                hml_db_user: this.hml_db_user,
                hml_db_password: this.hml_db_password,
              },
            });
          }
          if (key == 1023) {
            Object.assign(data, {
              1023: {
                url: this.yfj_url,
                api_id: this.yfj_api_id,
                secret: this.yfj_secret,
                stocks: this.yfj_stocks,
              },
            });
          }
          if (key == 1025) {
            Object.assign(data, {
              1025: {
                sanlian_url: this.sanlian_url,
                sanlian_random_str: this.sanlian_random_str,
              },
            });
          }
          if (key == 1026) {
            Object.assign(data, {
              1026: {
                zhonglun_url: this.zhonglun_url,
                zhonglun_appKey: this.zhonglun_appKey,
                zhonglun_appSecret: this.zhonglun_appSecret,
                zhonglun_supplierId: this.zhonglun_supplierId,
                zhonglun_mid_url: this.zhonglun_mid_url,
                zhonglun_mid_auth: this.zhonglun_mid_auth,
              },
            });
          }
          if (key == 1017) {
            Object.assign(data, {
              1017: {
                fp_url: this.fp_url,
                fp_app_id: this.fp_app_id,
                fp_secret: this.fp_secret,
              },
            });
          }
          if (key == 2002) {
            Object.assign(data, {
              2002: {
                push_shop: this.push_shop,
                push_stock: this.push_stock,
                push_gwall_url: this.push_gwall_url,
              },
            });
          }
          if (key == 2001) {
            Object.assign(data, {
              2001: {
                push_mid_url: this.push_mid_url,
                push_mid_auth: this.push_mid_auth,
                push_mid_token: this.push_mid_token,
              },
            });
          }
          if (key == 1018) {
            Object.assign(data, {
              1003: {
                push_kingdee_url: this.push_kingdee_url,
                push_kingdee_auth: this.push_kingdee_auth,
                push_kingdee_token: this.push_kingdee_token,
              },
            });
          }
          if (key == 2101) {
            Object.assign(data, {
              2101: {
                push_middleware_url: this.push_middleware_url,
                push_middleware_auth: this.push_middleware_auth,
                // sync_base_data_from: this.sync_base_data_from,
                sync_material_data_from: this.sync_material_data_from,
                new_material_bind_template: this.new_material_bind_template,
                bind_template_ids: this.templateIds,
                new_material_bind_stock: this.new_material_bind_stock,
                bind_stock_ids: this.stockIds,
                new_material_bind_yywd_supplier: this.new_material_bind_yywd_supplier,
                bind_yywd_supplier_ids: this.supplierIds,
                new_material_bind_common_supplier: this.new_material_bind_common_supplier,
                bind_common_supplier_ids: this.commonSupplierIds,
                sync_supplier_data_from: this.sync_supplier_data_from,
                sync_shop_data_from: this.sync_shop_data_from,
                sync_kingdee_sell_order: this.sync_kingdee_sell_order
              },
            });
          }
          if (key == 1012) {
            Object.assign(data, {
              1012: {
                push_topmall_url: this.push_topmall_url,
                push_topmall_token: this.push_topmall_token,
              },
            });
          }

          if (key == 1013) {
            Object.assign(data, {
              1013: {
                push_ut_url: this.push_ut_url,
                push_ut_token: this.push_ut_token,
                push_ut_auth: this.push_ut_auth,
              },
            });
          }
          if (key == 1014) {
            let xibei_stock_settings = [];
            this.xibei_stocks.forEach((stock) => {
              if (stock.supplier_code != '' && stock.supplier_name != '') {
                xibei_stock_settings.push({
                  stock_id: stock.id,
                  supplier_code: stock.supplier_code,
                  supplier_name: stock.supplier_name,
                })
              }
            })
            Object.assign(data, {
              1014: {
                push_xibei_url: this.push_xibei_url,
                push_xibei_appkey: this.push_xibei_appkey,
                push_xibei_supplier_code: this.push_xibei_supplier_code,
                push_xibei_supplier_name: this.push_xibei_supplier_name,
                push_xibei_publickey: this.push_xibei_publickey,
                push_xibei_notice_email: this.push_xibei_notice_email,
                push_xibei_notice_phone: this.push_xibei_notice_phone,
                xibei_stock_settings: xibei_stock_settings,
              },
            });
          }
          if (key == 2003) {
            Object.assign(data, {
              2003: {
                yx_url: this.yx_url,
                yx_app_id: this.yx_app_id,
                yx_app_key: this.yx_app_key,
                yx_brand_id: this.yx_brand_id,
              },
            });
          }
        });
      }
      Settings.saveThirdApiSetting(data).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$snackbar.success(i18n.t("logisticsApiSetting.saveSuccess"));
            this.getThirdApiSettingFromAPI();
          }
        }.bind(this)
      );
    },

    getStockList() {
      Stocks.fetchAllForSelect({
        fieldFilter: [
          "id",
          "code",
          "name",
        ]
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.xibei_stocks = response.data.stocks.map((item) => {
              item.supplier_code = "";
              item.supplier_name = "";
              if (this.xibei_stock_settings) {
                this.xibei_stock_settings.find((setting) => {
                  if (setting.stock_id == item.id) {
                    item.supplier_code = setting.supplier_code;
                    item.supplier_name = setting.supplier_name;
                  }
                })
              }
              return item;
            });
          }
        }.bind(this)
      );
    },

    getTemplatesFromApi() {
      Template.fetchAllForSelect({}).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.templates = [];
              response.data.templates.map((template) => {
                if (this.templateIds.includes(template.id)) {
                  this.templates.push(template)
                }
              });
            }
          }.bind(this)
      );
    },

    getStocksFromApi() {
      let options = {
        fieldFilter: [
          "id",
          "code",
          "name",
          "type",
          "status",
          "StockDistrict.id"
        ],
        stock_ids: this.stockIds
      }
      Stocks.fetchAllNoPaging(options).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.stocks = response.data.stocks
            }
          }.bind(this)
      );
    },
    getSuppliersFromApi() {
      let options = {
        fieldFilter: [
          "id",
          "supplier_code",
          "supplier_name",
        ]
      }
      Suppliers.fetchAllNoPaging(options).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.suppliers = [];
              this.commonSuppliers = [];
              response.data.suppliers.map((supplier) => {
                if (this.supplierIds.includes(supplier.id)) {
                  this.suppliers.push(supplier)
                }
                if (this.commonSupplierIds.includes(supplier.id)) {
                  this.commonSuppliers.push(supplier)
                }
              });

              this.fetchTimestamp = new Date().getTime();
            }
          }.bind(this)
      );
    },
    addShop(shops) {
      shops.forEach((shop) => {
        this.kry_shops.push(shop)
      })
    },
  },

  watch: {
    // 监听单次选择的模板
    choosedTemplates: {
      handler() {
        //  综合多次选择的供应商
        this.choosedTemplates.map((template) => {
          this.templates.push(template)
        });
      },
    },
    templates: {
      deep: true,
      handler() {
        if (this.templates.length) {
          this.templateIds = this.templates.map((template) => {
            return template.id;
          });
        } else {
          this.templateIds = [];
        }
      },
    },
    // 监听单次选择的仓库
    choosedStocks: {
      handler() {
        //  综合多次选择的供应商
        this.choosedStocks.map((stock) => {
          this.stocks.push(stock)
        });
      },
    },
    stocks: {
      deep: true,
      handler() {
        if (this.stocks.length) {
          this.stockIds = this.stocks.map((stock) => {
            return stock.id;
          });
        } else {
          this.stockIds = [];
        }
      },
    },
    // 监听单次选择的平台供应商
    choosedSuppliers: {
      handler() {
        this.suppliers = [];
        this.suppliers.push(this.choosedSuppliers);
        //  综合多次选择的供应商
      },
    },
    suppliers: {
      deep: true,
      handler() {
        if (this.suppliers.length) {
          this.supplierIds = this.suppliers.map((supplier) => {
            return supplier.id;
          });
        } else {
          this.supplierIds = [];
        }
      },
    },
    // 监听单次选择的普通供应商
    choosedCommonSuppliers: {
      handler() {
        //  综合多次选择的供应商
        this.choosedCommonSuppliers.map((supplier) => {
          this.commonSuppliers.push(supplier)
        });
      },
    },
    commonSuppliers: {
      deep: true,
      handler() {
        if (this.commonSuppliers.length) {
          this.commonSupplierIds = this.commonSuppliers.map((supplier) => {
            return supplier.id;
          });
        } else {
          this.commonSupplierIds = [];
        }
      },
    },


    shopsSelected: {
      handler() {
        this.push_shop = this.shopsSelected
          ? this.shopsSelected.map((shop) => {
              return shop.id;
            })
          : [];
      },
    },
    stocksSelected: {
      handler() {
        this.push_stock = this.stocksSelected
          ? this.stocksSelected.map((stock) => {
              return stock.id;
            })
          : [];
      },
    },
    yfjStocksSelected: {
      handler() {
        this.yfj_stocks = this.yfjStocksSelected
          ? this.yfjStocksSelected.map((stock) => {
              return stock.id;
            })
          : [];
      },
    },
    push_ThirdApi_form: {
      handler() {
        if (!this.push_ThirdApi_form.length) {
          this.panels = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
        }else {
          this.push_ThirdApi_form.find((item) => {
            if (item == 1014) {
              this.getStockList()
            }
          })
        }

      },
    },
    kry_shops: {
      handler() {
        if (this.kry_shops.length == 0) {
          this.kry_setting = {};
        } else {
          let setting = {};
          this.kry_shops.forEach((shop) => {
            if (this.kry_setting[shop.shop_code]) {
              this.$set(
                setting,
                shop.shop_code,
                this.kry_setting[shop.shop_code]
              );
            }
          });
          this.kry_setting = setting;
        }
      },
    },
  },
};
</script>